import { Box, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useState } from 'react';
import { CustomerAnalyticsStyles } from './CustomerAnalyticsStyles';

interface StatusDropdownProps {
  onStatusChange: (status: string) => void;
}

const StatusDropdown: React.FC<StatusDropdownProps> = ({ onStatusChange }) => {
  const [status, setStatus] = useState('All');

  const handleStatusChange = (value: string) => {
    setStatus(value);
    onStatusChange(value);
  };

  return (
    <Box sx={CustomerAnalyticsStyles.statusDropdown}>
      <FormControl fullWidth size="small">
        <InputLabel id="status-label">Status</InputLabel>
        <Select
          labelId="status-label"
          value={status}
          label="Status"
          onChange={e => handleStatusChange(e.target.value)}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="Success">Success</MenuItem>
          <MenuItem value="Failed">Failed</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default StatusDropdown; 